export default __webpack_public_path__ + "static/1287-db7e9547324f1547a2b52f1614b6b0df.gif";